import moment from 'moment';
import { getCaveats } from '../../HttpRequests/caveats';
import { loadCaveats } from '../State/caveats';

let lastGetTimestamp = null;

const cacheTTL = 60000;

export default ({ force } = {}) => async (dispatch) => {

  try {

    if (!force && lastGetTimestamp) {

      const now = Number(moment().format('x'));

      if (now < (lastGetTimestamp + cacheTTL)) return;
    }
      
    lastGetTimestamp = Number(moment().format('x'));

    const params = {
      pagination: 0,
      sort: 'type'
    }

    const response = await getCaveats({ params });

    dispatch(loadCaveats(response.data.data));

  } catch (error) {
    
    throw error;

  }
}